/* Fashion Point Plus — mobile card-swipe category showcase.
 * Desktop keeps the original scroll-driven sticky editorial.
 * Mobile: card coverflow with adjacent previews, synchronized product carousel.
 */
(function(){
'use strict';
function mount(root){
 if(root.dataset.fppStickyReady==='1')return;
 root.dataset.fppStickyReady='1';
 var chapters=Array.from(root.querySelectorAll('[data-fpp-chapter]'));
 var panels=Array.from(root.querySelectorAll('[data-fpp-panel]'));
 var counter=root.querySelector('[data-fpp-current]');
 var previousDesktop=-1,desktopFrame=0;
 function updateDesktop(){
   desktopFrame=0;
   if(window.innerWidth<=900)return;
   var threshold=window.innerHeight*.43;
   var active=0;
   chapters.forEach(function(chapter,i){if(chapter.getBoundingClientRect().top<=threshold)active=i});
   if(active===previousDesktop)return;
   previousDesktop=active;
   panels.forEach(function(panel,i){panel.classList.toggle('is-active',i===active)});
   if(counter)counter.textContent=String(active+1).padStart(2,'0');
 }
 function scheduleDesktop(){
   if(!desktopFrame)desktopFrame=requestAnimationFrame(updateDesktop);
 }
 window.addEventListener('scroll',scheduleDesktop,{passive:true});
 window.addEventListener('resize',scheduleDesktop,{passive:true});
 updateDesktop();

 var mobile=root.querySelector('[data-fpp-mobile]');
 if(!mobile)return;
 var viewer=mobile.querySelector('[data-fpp-mobile-swipe]');
 var slides=Array.from(mobile.querySelectorAll('[data-fpp-mobile-slide]'));
 var sets=Array.from(mobile.querySelectorAll('[data-fpp-mobile-products]'));
 var title=mobile.querySelector('[data-fpp-mobile-title]');
 var explore=mobile.querySelector('[data-fpp-mobile-explore]');
 if(!slides.length||!viewer)return;
 var index=0,resumeTimer=null,frame=null,lastFrame=0,loopDistance=0;
 var isVisible=false,isPaused=false;
 var prefersReduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)');
 var touchStartX=null,touchStartY=null,mouseStartX=null,suppressSideClickUntil=0;
 function reduce(){return !!(prefersReduced&&prefersReduced.matches)}
 function activeTrack(){var set=sets[index];return set&&set.querySelector('[data-fpp-mobile-track]')}
 function mayPlay(){return isVisible&&!document.hidden&&!isPaused&&!reduce()&&window.innerWidth<=900}
 function stop(){
   if(frame!==null){cancelAnimationFrame(frame);frame=null;}
   lastFrame=0;
 }
 /* Continuous real-time ticker, 27px/sec; duplicates render only for a
    seamless loop and are hidden from screen readers and keyboard focus. */
 function tick(now){
   frame=null;
   if(!mayPlay())return;
   var track=activeTrack();
   if(!track||!track.classList.contains('fpp-is-ticker'))return;
   if(!loopDistance){
     var first=track.querySelector('.fpp-sticky__mobile-product:not([data-fpp-clone])');
     var clone=track.querySelector('.fpp-sticky__mobile-product[data-fpp-clone]');
     if(!first||!clone)return;
     loopDistance=clone.offsetLeft-first.offsetLeft;
     if(loopDistance<5)return;
   }
   if(lastFrame){
     var delta=Math.min(Math.max(now-lastFrame,0),45);
     var position=track.scrollLeft+delta*.027;
     if(position>=loopDistance)position-=loopDistance;
     track.scrollLeft=position;
   }
   lastFrame=now;
   frame=requestAnimationFrame(tick);
 }
 function play(){
   stop();
   if(mayPlay()&&activeTrack()&&activeTrack().classList.contains('fpp-is-ticker')){
     frame=requestAnimationFrame(tick);
   }
 }
 function pauseForInteraction(){
   isPaused=true;
   stop();
   if(resumeTimer!==null)clearTimeout(resumeTimer);
   resumeTimer=setTimeout(function(){isPaused=false;play()},4300);
 }
 /* Arrange ALL cards in a circular 3D coverflow. The adjacent category cards
    remain visible and tappable, unlike the old overlay-only slide transition. */
 function choose(rawIndex){
   var len=slides.length;
   var i=(rawIndex+len)%len;
   index=i;
   slides.forEach(function(el,j){
     var distance=(j-i+len)%len;
     el.classList.remove('is-entering','is-leaving','to-left','to-right','from-left','from-right');
     el.classList.toggle('is-active',distance===0);
     el.classList.toggle('is-next',distance===1);
     el.classList.toggle('is-prev',distance===len-1&&distance!==1);
     el.classList.toggle('is-far',distance!==0&&distance!==1&&distance!==len-1);
     el.setAttribute('aria-hidden',String(distance!==0));
   });
   loopDistance=0;
   sets.forEach(function(set,j){
     var selected=j===i;
     set.hidden=!selected;
     if(selected){
       var track=set.querySelector('[data-fpp-mobile-track]');
       if(track)track.scrollLeft=0;
     }
   });
   if(title)title.textContent=slides[i].getAttribute('data-title')||'Our edit';
   if(explore)explore.href=slides[i].getAttribute('data-link')||'/collections/all';
   play();
 }
 function move(direction){choose(index+direction)}
 slides.forEach(function(slide,j){
   slide.addEventListener('click',function(){
     if(Date.now()<suppressSideClickUntil)return;
     if(j!==index)choose(j);
   });
 });
 viewer.addEventListener('touchstart',function(event){
   if(event.touches.length!==1)return;
   touchStartX=event.touches[0].clientX;
   touchStartY=event.touches[0].clientY;
 },{passive:true});
 viewer.addEventListener('touchend',function(event){
   if(touchStartX===null||!event.changedTouches.length)return;
   var dx=event.changedTouches[0].clientX-touchStartX;
   var dy=event.changedTouches[0].clientY-touchStartY;
   touchStartX=null;touchStartY=null;
   if(Math.abs(dx)>36&&Math.abs(dx)>Math.abs(dy)*1.15){
     suppressSideClickUntil=Date.now()+450;
     move(dx<0?1:-1);
   }
 },{passive:true});
 viewer.addEventListener('pointerdown',function(event){
   if(event.pointerType==='mouse')mouseStartX=event.clientX;
 });
 viewer.addEventListener('pointerup',function(event){
   if(event.pointerType==='mouse'&&mouseStartX!==null){
     var delta=event.clientX-mouseStartX;mouseStartX=null;
     if(Math.abs(delta)>46){suppressSideClickUntil=Date.now()+450;move(delta<0?1:-1)}
   }
 });
 viewer.addEventListener('keydown',function(event){
   if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
     event.preventDefault();move(event.key==='ArrowRight'?1:-1);
   }
 });
 /* Duplicate the *existing* product cards once to make the scroll
    continuous. Never generate fictitious products or ratings. */
 sets.forEach(function(set){
   var track=set.querySelector('[data-fpp-mobile-track]');
   if(!track||track.dataset.fppTickerReady==='1')return;
   track.dataset.fppTickerReady='1';
   var realCards=Array.from(track.querySelectorAll('.fpp-sticky__mobile-product'));
   if(realCards.length<2)return;
   realCards.forEach(function(card){
     var clone=card.cloneNode(true);
     clone.setAttribute('data-fpp-clone','');
     clone.setAttribute('aria-hidden','true');
     clone.querySelectorAll('a,button,[tabindex]').forEach(function(a){a.setAttribute('tabindex','-1')});
     track.appendChild(clone);
   });
   track.classList.add('fpp-is-ticker');
 });
 sets.forEach(function(set){
   var track=set.querySelector('[data-fpp-mobile-track]');
   if(!track)return;
   track.addEventListener('pointerdown',pauseForInteraction,{passive:true});
   track.addEventListener('touchstart',pauseForInteraction,{passive:true});
   track.addEventListener('keydown',pauseForInteraction);
 });
 if('IntersectionObserver' in window){
   var observer=new IntersectionObserver(function(entries){
     isVisible=entries.some(function(entry){return entry.isIntersecting});
     play();
   },{threshold:0.08});
   observer.observe(mobile.querySelector('.fpp-sticky__mobile-product-area')||mobile);
 }else{isVisible=true}
 document.addEventListener('visibilitychange',play);
 window.addEventListener('resize',function(){loopDistance=0;play()},{passive:true});
 if(prefersReduced&&prefersReduced.addEventListener)prefersReduced.addEventListener('change',play);
 root.addEventListener('shopify:block:select',function(event){
   var chapter=event.target.closest('[data-fpp-mobile-slide]');
   if(chapter)choose(Number(chapter.getAttribute('data-fpp-mobile-slide'))||0);
 });
 choose(0);
}
function init(){document.querySelectorAll('[data-fpp-sticky]').forEach(mount)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',init);
})();